<template>
    <span>
        <home-calendar></home-calendar>
    </span>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import { mapActions } from 'vuex';
import HomeCalendar from '@/components/HomeCalendar';

export default {
    name: 'home',
    data() {
        return {};
    },
    components: {
        HomeCalendar
    },
    methods: {},
    created() {
        console.log('Home Calendar created...');
    }
};
</script>
